import { FC, useState } from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";

export const Styles = styled.div`
  background: url("/images/field-height.png") repeat-y 100% 0 !important;
  position: absolute;
  height: 100%;
  width: 2px;
  z-index: 10;
`;
interface PropsResizingBar {
  container: HTMLElement | null;
  left: number;
  isMatching: boolean;
}
const ResizingBar: FC<PropsResizingBar> = ({ container, left, isMatching }) => {
  const { left: leftContainer, top: topContainer } =
    container?.getBoundingClientRect() || {
      left: 0,
    };
  const isShow = container && isMatching;
  const top = 120;
  const height = `calc(100% - ${top}px)`;
  return isShow ? (
    <div>
      {createPortal(
        <Styles
          style={{
            left: left,
            top,
            height,
          }}
        ></Styles>,
        document.body,
      )}
    </div>
  ) : (
    <></>
  );
};

export default ResizingBar;
